import {
  InvoiceResult,
  TokenRequest,
  TokenResult,
  ViewPaymentRequest,
  ViewPaymentResult,
} from "../domain/entity/Main";

import MainRepository from "../repository/MainRepository";

export default class MainUseCase implements MainRepository {
  constructor(private repository: MainRepository) {
    this.repository = repository;
  }

  getToken(body: TokenRequest): Promise<TokenResult> {
    return this.repository.getToken(body);
  }

  getInvoice(): Promise<InvoiceResult> {
    return this.repository.getInvoice();
  }

  getViewPayment(body: ViewPaymentRequest): Promise<ViewPaymentResult> {
    return this.repository.getViewPayment(body);
  }

  download(): Promise<any> {
    return this.repository.download();
  }

  getImagePath(path: string): Promise<any> {
    return this.repository.getImagePath(path);
}
}
